import { getDefaultApiSources } from '#pplx/frontend/apps/ask/sources/hooks/internal/defaultSources.js';
import { isOmittedSourceType } from '#pplx/frontend/apps/ask/sources/hooks/internal/isOmittedSource.js';
export function getSourceQueryData({ data, intl, }) {
    // Use default sources as fallback only when data is undefined (no API response yet)
    // If data exists but sources is empty, respect that (don't fall back to defaults)
    const hasApiResponse = data !== undefined;
    const allSourcesFromApi = data?.pages.flatMap((page) => page?.sources ?? []) ?? [];
    const allSources = hasApiResponse ? allSourcesFromApi : getDefaultApiSources(intl);
    const engineMode = data?.pages.find((page) => page?.engine_mode)?.engine_mode ?? 'unified';
    const filteredSources = allSources.filter((source) => !isOmittedSourceType(source.id));
    // Create map for efficient lookup. Grouped responses embed selectable
    // family members inside the primary row; index them so by-ID lookups for
    // member IDs (previously top-level entries) keep resolving, without adding
    // members to the top-level list.
    const sourcesMap = new Map();
    filteredSources.forEach((source) => {
        sourcesMap.set(source.id, source);
    });
    filteredSources.forEach((source) => {
        source.family_info?.members?.forEach((member) => {
            if (!isOmittedSourceType(member.id) && !sourcesMap.has(member.id)) {
                sourcesMap.set(member.id, member);
            }
        });
    });
    const getSource = (sourceId) => {
        return sourcesMap.get(sourceId);
    };
    return [filteredSources, getSource, engineMode];
}
//# sourceMappingURL=getSourceQueryData.js.map